<template>
  <div class="BaseButton__group" :class="direction">
    <slot />
  </div>
</template>

<script setup lang="ts">
  interface Props {
    direction?: 'column' | 'row';
  }

  withDefaults(defineProps<Props>(), {
    direction: 'column',
  });
</script>

<style scoped lang="scss">
  .BaseButton__group {
    display: flex;
    gap: 1.0448vw;
    width: 100%;
    height: 100%;

    &.row {
      flex-direction: row;
    }
  }
</style>
